import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SETTINGS } from '../config/common.settings';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  allCustomers: any;
  allActiveCustomers: any;
  customer: any;

  constructor(private http: HttpClient) {}

  getAllCustomers(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/customers/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            this.allCustomers = response[0];
            resolve(this.allCustomers);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getAllActiveCustomers(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/customers/get-all`).subscribe({
        next: (response: any) => {
          this.allActiveCustomers = response;
          resolve(this.allActiveCustomers);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  getCustomerByID(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/customers/get/${id}`).subscribe({
        next: (response: any) => {
          this.customer = response;
          resolve(this.customer);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  createCustomer(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/customers/create`, payload)
        .subscribe({
          next: (response: any) => {
            this.customer = response;
            resolve(this.customer);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateCustomer(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/customers/update`, payload)
        .subscribe({
          next: (response: any) => {
            this.customer = response;
            resolve(this.customer);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  deleteCustomer(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(`${SETTINGS.BASE_API}/customers/delete/${id}`)
        .subscribe({
          next: (response: any) => {
            const deleteCustomer = response;
            resolve(deleteCustomer);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
}
